import { parsedObjectInfoI } from '@/interfaces/parsedObjectInfoI';

class Node {
  nodeIdx: number;
  data: parsedObjectInfoI;
  parentNodeNum: number | null;
  childrenNodeNum: number[];

  constructor(
    nodeIdx: number,
    data: parsedObjectInfoI,
    parentNodeNum: number | null = null,
  ) {
    this.nodeIdx = nodeIdx;
    this.data = data;
    this.parentNodeNum = parentNodeNum;
    this.childrenNodeNum = [];
  }
}

export class Tree {
  nodes: Node[];

  constructor() {
    const rootNodeData: parsedObjectInfoI = {
      name: 'root',
      type: 'object',
      example: '',
      depth: 0,
      isItem: false,
    };
    this.nodes = [new Node(0, rootNodeData)];
  }

  add(data: parsedObjectInfoI): void {
    const newNodeIdx = this.nodes.length;

    let parentNode = this.nodes[this.nodes.length - 1];
    while (
      parentNode.data.depth >= data.depth &&
      parentNode.parentNodeNum !== null
    ) {
      parentNode = this.nodes[parentNode.parentNodeNum];
    }

    parentNode.childrenNodeNum.push(newNodeIdx);
    this.nodes.push(new Node(newNodeIdx, data, parentNode.nodeIdx));
  }

  getData(nodeNum = 0): parsedObjectInfoI[] {
    const currentNode = this.nodes[nodeNum];
    let data: parsedObjectInfoI[] = [];
    data.push(currentNode.data);

    for (const childNodeIdx of currentNode.childrenNodeNum) {
      data = data.concat(this.getData(childNodeIdx));
    }

    return data;
  }

  getArrayLeafData(nodeNum = 0): {
    nodeIdxList: number[];
    parsedObject: parsedObjectInfoI[];
  } {
    const currentNode = this.nodes[nodeNum];
    let nodeIdxList: number[] = [];
    let parsedObject: parsedObjectInfoI[] = [];
    nodeIdxList.push(nodeNum);
    parsedObject.push(currentNode.data);

    if (currentNode.data.type === 'array') {
      return { nodeIdxList, parsedObject };
    }

    for (const childNodeIdx of currentNode.childrenNodeNum) {
      const childArrayLeafData = this.getArrayLeafData(childNodeIdx);
      nodeIdxList = nodeIdxList.concat(childArrayLeafData.nodeIdxList);
      parsedObject = parsedObject.concat(childArrayLeafData.parsedObject);
    }

    if (nodeIdxList.length === 1) {
      nodeIdxList.pop();
      parsedObject.pop();
    }

    return { nodeIdxList, parsedObject };
  }

  getParentName(nodeNum = 0): string {
    let currentNode = this.nodes[nodeNum];
    //const nodeIdxList: number[] = [];
    const parsedObject: parsedObjectInfoI[] = [];

    while (currentNode.parentNodeNum !== null) {
      //nodeIdxList.push(currentNode.nodeIdx);
      parsedObject.push(currentNode.data);
      currentNode = this.nodes[currentNode.parentNodeNum];
    }

    return parsedObject
      .reverse()
      .map((x: parsedObjectInfoI) => {
        return x.name;
      })
      .join('.');
    //nodeIdxList: nodeIdxList.reverse(),
  }
}
